module.exports = __webpack_public_path__ + "static/media/logo512.936a13a6.svg";